
import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function GetCustomerContracts(
  salesOrg: string,
  customerNum: string
): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
      salesOrg: salesOrg,
      customerNum: customerNum,
    },
    url: `${BASE_URL}/api/admin/contracts/customer`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => {
      console.error("Error fetching customer contracts:", err);
      throw err;
    });
}
